/** Thông tin thương hiệu — sửa tại đây, mọi nơi trong app tự cập nhật. */
export const SITE = {
  name: "Claude Zero to Hero",
  shortName: "Zero to Hero",
  tagline: { vi: "Từ con số 0 tới Claude Certified Architect", en: "From zero to Claude Certified Architect" },
  domain: "claude-zerotohero",
  /** URL đầy đủ (có https và đuôi tên miền) — dùng cho link chia sẻ. */
  url: "https://claude-zerotohero.com",
  owner: "briancao",
  /** Ngày rà soát nội dung gần nhất so với tài liệu chính thức. */
  contentReviewedAt: "2026-11-04",
  startYear: 2026,
  /** Repo công khai — nhận góp ý qua GitHub Issues khi chưa cấu hình endpoint. */
  repo: "https://github.com/NhatCaoIT/claude-zerotohero",
  /** Endpoint nhận góp ý (backend riêng, lưu vào PostgreSQL). */
  feedbackEndpoint: `${((import.meta.env?.VITE_API_URL as string | undefined) ?? "/api").replace(/\/$/, "")}/feedback`,
} as const;
